// extracted by mini-css-extract-plugin
export default {"root":"UserRequestsTable_root__orO3s","row":"UserRequestsTable_row__D7rwA","boxMargin":"UserRequestsTable_boxMargin__d4GA6","fullHeight":"UserRequestsTable_fullHeight__Y0Kzy"};